import styled from "styled-components";

import { Row } from "components/common";
import colors from "styles/colors";

const Container = styled(Row)`
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

const FilterContainer = styled(Row)`
  white-space: nowrap;
  line-height: 2em;
`;

const FilterLabel = styled.text`
  font-weight: bold;
  margin-right: 4px;
  white-space: nowrap;
`;

const FilterValue = styled.div`
  color: ${({ hasColor }) =>
    hasColor ? colors.coreColors.jllRed.primary : ""};
`;

const VerticalDivider = styled.div`
  &::before {
    content: "|";
  }
  margin: 0px 12px;
`;

const MainMessage = styled.div`
  color: var(--alert-errorContent, var(--alert-errorContent, #b0133a));
  font-feature-settings: "liga" off, "clig" off;

  /* components/alert-title */
  font-family: "Source Sans Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
  letter-spacing: 0.15px;
`;

const SubMessage = styled.div`
  color: var(--alert-errorContent, var(--alert-errorContent, #b0133a));
  font-feature-settings: "liga" off, "clig" off;
  /* typography/body2 */
  font-family: "Source Sans Pro";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%; /* 20.02px */
  letter-spacing: 0.17px;
`;

export {
  Container,
  FilterContainer,
  FilterLabel,
  FilterValue,
  VerticalDivider,
  MainMessage,
  SubMessage,
};
